import {AuthenticationState} from './authentication-state';
import {
    loadAuthFailed,
    loadAuthStart,
    loadAuthSucceeded, loadDelegantSucceedAction, logoutAuthFailed, logoutAuthSucceeded, removeDelegantSucceedAction
} from './authentication.action';
import { createReducer, on } from '@ngrx/store';
import * as _ from 'lodash';


export const AUTH_INITIAL_STATE: AuthenticationState = {
  authenticated: false,
  role: undefined,
  error: null,
  loading: false,
  datas: {}
};


export const authenticationReducer = createReducer(
    AUTH_INITIAL_STATE,
    on(loadAuthStart, (state) => {
        return {
            ...state,
            authenticated: false,
            role: undefined,
            loading: true,
            error: null,
        };
    }),
    on(loadAuthSucceeded, (state, {role}) => {
        return {
            ...state,
            role: role,
            authenticated: true,
            loading: false,
            error: null,
        };
    }),
    on(loadAuthFailed, (state, {error}) => {
        return {
            ...state,
            authenticated: false,
            role: undefined,
            loading: false,
            error: error,
        };
    }),
    on(loadDelegantSucceedAction, (state, {payload} ) => {
        return {
            ...state,
            datas: {delegant: payload},
            authenticated: true,
            loading: false,
            error: null,
        };
    }),
    on(removeDelegantSucceedAction, (state ) => {
        const stateCopy = _.cloneDeep(state);
        delete stateCopy.datas.delegant;

        return {
            ...stateCopy,
            authenticated: true,
            loading: false,
            error: null
        };
    }),

    on(logoutAuthSucceeded, (state) => {
        return {
            ...state,
            authenticated: false,
            role: undefined,
            loading: false,
            error: null,
        };
    }),
    on(logoutAuthFailed, (state, {error}) => {
        return {
            ...state,
            authenticated: false,
            role: undefined,
            loading: false,
            error: error,
        };
    }),
);